import styled from 'styled-components';

import { Container } from '@main/core-ui';

/**
 * The NotFound wrapper
 */
export const NotFoundWrapper = styled(Container)`
  padding-bottom: 100px;
  padding-top: 40px;
`;
